<template>
<div>
    <h3>Información General</h3>
    <div class="card" v-loading="loading" element-loading-text="Cargando..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
        <div class="card-body">
            <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Nombre del Curso</label>
                                    <input type="text" v-model="form.title" class="form-control" placeholder="Titulo del curso" />
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Tipo de curso</label>
                                    <el-select v-model="form.id_categories" placeholder="Tipo de producto" size="large">
                                        <el-option v-for="(
                                                    productType, index
                                                ) in categoriesList" :key="index" :label="productType.producto" :value="productType.id" />
                                    </el-select>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label>Acerca de este curso</label>
                                    <textarea
                                    class="form-control"
                                    v-model="form.description"
                                    rows="5"
                                    style="resize: none"
                                    placeholder="Descripción del curso"
                                    ></textarea>
                                    <!-- <QuillEditor v-model:content="form.description" contentType="html" theme="snow" :toolbar="modules.toolbar" :modules="modules" placeholder="Describa el producto" /> -->
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Precio</label>
                                    <br>
                                    <el-input-number  placeholder="1" v-model="form.price"/>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Meses de duración</label>
                                    <el-input-number placeholder="1" v-model="form.months"/>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Categoria de curso</label>
                                    <el-select v-model="form.course_categories_id" placeholder="Categoría de curso" size="large">
                                        <el-option v-for="(
                                                    category, index
                                                ) in courseCategory" :key="index" :label="category.name" :value="category.id" />
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <label>Subir Imagen Portada</label>
                        <el-upload class="picture-card" ref="courseUpload" action="" drag accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG, .webp, .WEBP, .avif, .AVIF" :on-change="onImageUploadChange" :http-request="submit" :multiple="false" :limit="1" :auto-upload="false" :file-list="fileImageList" :on-exceed="handleExceedImage">
                            <em class="el-icon-upload"></em>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Solo archivos jpg/png/webp con un tamaño
                                menor de 3mb
                            </div>
                        </el-upload>
                        <label>Video</label>
                        <el-upload
                            class="upload-demo"
                            ref="uploadClassVideo"
                            action=""
                            :on-change="onUploadVideoChange"
                            :http-request="submit"
                            drag
                            :limit="1"
                            :auto-upload="false"
                            :file-list="fileVideoList"
                            :on-exceed="handleExceedVideo"
                            :on-remove="handleRemoveVideo"
                            accept=".mp4"
                            list-type="text"
                        >
                            <em class="el-icon-upload"></em>
                            <div class="el-upload__text">
                                Suelta tu archivo aquí o
                                <em>haz clic para cargar</em>
                            </div>
                            <div slot="tip" class="el-upload__tip">
                                Solo archivos mp4
                            </div>
                        </el-upload>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Objetivos del programa</label>
                            <textarea
                            class="form-control"
                            v-model="form.course_about"
                            rows="5"
                            style="resize: none"
                            placeholder="Describa los objetivos del programa"
                            ></textarea>
                            <!-- <QuillEditor v-model:content="form.course_about" contentType="html" theme="snow" :toolbar="modules.toolbar" :modules="modules" placeholder="Describa los objetivos del programa" /> -->
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Metodología de estudio</label>
                            <textarea
                            class="form-control"
                            v-model="form.will_learn"
                            rows="5"
                            style="resize: none"
                            placeholder="Describa la metodología de estudio"
                            ></textarea>
                            <!-- <QuillEditor v-model:content="form.will_learn" contentType="html" theme="snow" :toolbar="modules.toolbar" :modules="modules" placeholder="Describa la metodología de estudio" /> -->
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Conocimientos previos</label>
                            <textarea
                            class="form-control"
                            v-model="form.prev_knowledge"
                            rows="5"
                            style="resize: none"
                            placeholder="Describa los conocimientos previos"
                            ></textarea>
                            <!-- <QuillEditor v-model:content="form.prev_knowledge" contentType="html" theme="snow" :toolbar="modules.toolbar" :modules="modules" placeholder="Describa los conocimientos previos" /> -->
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>¿A quién va dirigido?</label>
                            <textarea
                            class="form-control"
                            v-model="form.course_for"
                            rows="5"
                            style="resize: none"
                            placeholder="Describa a quiénes va destinado el curso"
                            ></textarea>
                            <!-- <QuillEditor v-model:content="form.course_for" contentType="html" theme="snow" :toolbar="modules.toolbar" :modules="modules" placeholder="Describa a quienes va destinado el curso" /> -->
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="submit" class="btn btn-success" :disabled="isSubmitting">
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import {
    QuillEditor
} from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import BlotFormatter from "quill-blot-formatter";

export default {
    props: {
        courseCategory: Array,
        categoriesList: Array,
        route: String,
    },
    components: {
        QuillEditor,
    },
    data() {
        return {
            // https://quilljs.com/docs/modules/toolbar/
            modules: {
                name: "blotFormatter",
                module: BlotFormatter,
                toolbar: [
                    [{
                        header: [1, 2, 3, 4, 5, 6, false]
                    }],
                    [{
                        font: []
                    }],
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote"],
                    [{
                        list: "ordered"
                    }, {
                        list: "bullet"
                    }],
                    [{
                        indent: "-1"
                    }, {
                        indent: "+1"
                    }],
                    [{
                        color: []
                    }, {
                        background: []
                    }],
                    [{
                        align: []
                    }],
                    ["link"],
                ],
            },
            loading: false,
            extensions: ".jpeg, .jpg, .png, .webp, .avif",
            categories: [],
            form: {
                id_categories: "",
            },

            fileImageList: [],
            fileVideoList: [],
            isSubmitting: false,
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        handleExceedImage(file) {
            const isLt1M = file.size > 3000000;

            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 3Mb!");
                this.$refs.courseUpload.clearFiles();
                return false;
            }
        },
        handleExceedVideo(video) {
            this.$message.warning(`El límite es 1 video`);
        },
        handleRemoveVideo(fileremoved, fileVideo) {
            this.fileVideoList = fileVideo;
        },
        onUploadVideoChange(video) {
            this.fileVideoList = [];
            const isVideo = video.raw.type === "video/mp4";
            // 40mb
            const fortymb = 419430400000;
            const isLt3MB = video.size < fortymb;

            if (!isVideo) {
                this.$message.error(
                    "Solo puede cargar archivos en formato .mp4"
                );
                return false;
            }

            if (!isLt3MB) {
                this.$message.error("El archivo no debe pesar más de 40 mb!");
                return false;
            }
            this.fileVideoList.push(video);
        },
        onImageUploadChange(file) {
            this.fileImageList = [];

            const isImage =
                file.raw.type === "image/jpeg" ||
                file.raw.type === "image/webp" ||
                file.raw.type === "image/png" ||
                file.raw.type === "image/avif" ||
                file.raw.type === "image/jpg";

            // 100kb
            const isLt1M = file.size < 3000000;

            if (!isImage) {
                this.$message.error(
                    "Solo puede cargar archivos en formato jpg|jpeg|png."
                );
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 3Mb!");
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            // let reader = new FileReader();
            // reader.readAsDataURL(file.raw);
            // reader.onload = function (e) {
            //   console.log(this.result);
            // };
            this.fileImageList.push(file);
        },

        handleLevelChange(value) {
            if (value == 1) {
                this.form.price = "0";
            }
        },
        initForm() {
            this.form = {
                id: null,
                title: null,
                id_categories: null,
                description: null,
                // id_level: null,
                price: null,
                course_about: null,
                will_learn: null,
                prev_knowledge: "Ninguno",
                course_for: null,
                months: 3,
            };
        },
        hasEspecialCharacters(text) {
            // Solo puede contener vocales con tilde A-Z  y 0-9
            const regex = new RegExp(
                /^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g
            );
            return regex.test(text);
        },
        validateFields() {
            if (
                !this.form.title ||
                this.form.title.trim() === "" ||
                this.form.title.length === 0
            ) {
                this.$message.warning("Titulo esta vacio!");
                return false;
            }

            if (this.form.title.length > 300) {
                this.$message.warning("Titulo demasiado largo!");
                return false;
            }

            if (
                !this.form.id_categories ||
                this.form.id_categories.length === 0
            ) {
                this.$message.warning("No ha seleccionado el tipo de curso");
                return false;
            }

            if (
                !this.form.course_categories_id ||
                this.form.course_categories_id.length === 0
            ) {
                this.$message.warning(
                    "No ha seleccionado la categoría del curso"
                );
                return false;
            }

            if (
                !this.form.description ||
                this.form.description.trim() === "" ||
                this.form.description.length === 0
            ) {
                this.$message.warning("Descripcion esta vacio!");
                return false;
            }

            if (!this.$refs.courseUpload) {
                this.$message.warning("La portada del curso esta vacio!");
                return false;
            }

            // if (!this.form.id_level || this.form.id_level.length === 0) {
            //   this.$message.warning('No ha seleccionado el nivel del curso');
            //   return false;
            // }

            // if (this.form.id_level != 1) {
            //   if (!this.form.price || this.form.price.trim() === '' || this.form.price.length === 0) {
            //     this.$message.warning('Precio esta vacio o su valor es 0!');
            //     return false;
            //   }
            // }
            // if (this.form.id_level != 1) {
            //   if (this.form.price.charAt(0) == 0 || isNaN(this.form.price) == true) {
            //     this.$message.warning('Verifique el campo de precio');
            //     return false;
            //   }
            // }

            // if (this.form.id_level == 1) {
            //   if (this.form.price > 0) {
            //     this.$message.warning('Los cursos de nivel básico tienen que ser gratuitos');
            //     return false;
            //   }
            //   if (isNaN(this.form.price) == true) {
            //     this.$message.warning('Verifique el campo de precio');
            //     return false;
            //   }
            // }

            if (this.form.price < 0) {
                this.$message.warning(
                    "El precio asignado al curso no es correcto"
                );
                return false;
            }

            if (this.form.price.length > 7) {
                this.$message.warning("El campo de precio es muy largo");
                return false;
            }

            if (this.form.months < 1) {
                this.$message.warning(
                    "Los meses de duración asignados al curso no son correctos"
                );
                return false;
            }

            if (this.form.months > 12) {
                this.$message.warning("Los meses de duración asignados al curso son muy largos");
                return false;
            }

            if (
                !this.form.course_about ||
                this.form.course_about.trim() === "" ||
                this.form.course_about.length === 0
            ) {
                this.$message.warning("Acerca del curso esta vacio!");
                return false;
            }

            if (
                !this.form.will_learn ||
                this.form.will_learn.trim() === "" ||
                this.form.will_learn.length === 0
            ) {
                this.$message.warning(
                    "Lo que aprenderás del curso esta vacio!"
                );
                return false;
            }
            if (
                !this.form.prev_knowledge ||
                this.form.prev_knowledge.trim() === "" ||
                this.form.prev_knowledge.length === 0
            ) {
                this.$message.warning(
                    "Los conocimientos previos del curso esta vacio!"
                );
                return false;
            }
            if (
                !this.form.course_for ||
                this.form.course_for.trim() === "" ||
                this.form.course_for.length === 0
            ) {
                this.$message.warning(
                    "El público destino del curso esta vacio!"
                );
                return false;
            }

            return true;
        },

        async submit() {
            if (this.validateFields()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append("title", this.form.title);
                formdata.append("id_categories", this.form.id_categories);
                formdata.append(
                    "course_categories_id",
                    this.form.course_categories_id
                );
                formdata.append("description", this.form.description);
                // formdata.append('id_level', this.form.id_level);
                formdata.append("price", this.form.price);
                formdata.append("course_about", this.form.course_about);
                formdata.append("will_learn", this.form.will_learn);
                formdata.append("prev_knowledge", this.form.prev_knowledge);
                formdata.append("course_for", this.form.course_for);
                formdata.append("months", parseInt(this.form.months));
                if (this.fileImageList.length > 0) {
                    formdata.append("imageFile", this.fileImageList[0].raw);
                }
                if (this.fileVideoList.length > 0) {
                    formdata.append("videoFile", this.fileVideoList[0].raw);
                }
                try {
                    this.loading = true;
                    const request = await axios({
                        url: "/course/store",
                        method: "post",
                        data: formdata,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                    });
                    const response =
                        request.status == 200 ?
                        this.$message.success(
                            "El curso ha sido registrado correctamente"
                        ) :
                        await this.$message.warning(
                            "Error al validar datos"
                        );
                    this.isSubmitting = false;
                    this.loading = false;
                    this.initForm();
                    this.fileImageList = [];
                    this.fileVideoList = [];
                    window.location.href = this.route;
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },
    },
};
</script>

<style>
.ql-editor {
    min-height: 120px;
}
</style>
